/** Days of day-by-day history the person's panel reads and draws. */
export const USER_USAGE_HISTORY_DAYS = 90

/** Tabs id: the sub-tab rides in the URL as `user-usage-tab`. */
export const USER_USAGE_TABS_ID = "user-usage"
